let header = document.querySelector("#header");
let menu = document.getElementById("js-menu");
let navBg = document.getElementById("js-nav-bg");
let list = document.querySelector(".l-header__list");
let close = document.querySelector(".is-close");
let spNav = document.querySelector(".l-header__nav-sp");

menu.addEventListener("click", () => {
  menu.classList.toggle("is-active-menu");
  list.classList.toggle("is-active-list");
  navBg.classList.toggle("is-active-nav-bg");
  spNav.classList.toggle("is-active-sp-nav");
});
spAccess.addEventListener("click", () => {
  navBg.classList.remove("is-active-nav-bg");
  menu.classList.remove("is-active-menu");
});

close.addEventListener("click", () => {
  list.classList.remove("is-active-list");
});

window.addEventListener("scroll", function () {
  let scrollPosition = window.scrollY;

  if (scrollPosition > 0) {
    header.classList.add("is-active-shadow");
  } else {
    header.classList.remove("is-active-shadow");
  }
});
